import { c as _c } from "react/compiler-runtime";
import { CardHeader } from "../ui/card";
import { FFLogo } from "./FFLogo";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const BrandCardHeader = t0 => {
  const $ = _c(9);
  const {
    title,
    subtitle
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = /*#__PURE__*/_jsx("div", {
      className: "m-0 mb-4 inline-flex items-center justify-center p-0",
      children: /*#__PURE__*/_jsx(FFLogo, {
        className: "cursor-auto"
      })
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== title) {
    t2 = /*#__PURE__*/_jsx("h2", {
      className: "text-2xl font-semibold",
      children: title
    });
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== subtitle) {
    t3 = /*#__PURE__*/_jsx("p", {
      className: "text-muted-foreground text-sm",
      children: subtitle
    });
    $[3] = subtitle;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = /*#__PURE__*/_jsx("div", {
      className: "from-branding/50 via-branding to-branding/50 absolute left-0 top-0 h-1 w-full bg-gradient-to-r"
    });
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t3) {
    t5 = /*#__PURE__*/_jsxs(CardHeader, {
      className: "border-branding/20 relative flex flex-col items-center space-y-1.5 border-b p-6 text-center",
      children: [t1, t2, t3, t4]
    });
    $[6] = t2;
    $[7] = t3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};